<button
    class="card flex justify-center items-center bg-primary rounded-[10px] text-center h-[50px] w-full text-white font-bold max-w-screen-sm transition duration-300 ease-in-out focus:ring-2 focus:ring-black"
    [class.cursor-not-allowed]="isDisabled" [class.bg-neutral-1000]="isDisabled" [disabled]="isDisabled"
    [class.hover:bg-primary-1200]="!isDisabled" (click)="onClick()">
    {{ buttonText }}
</button>